import React from 'react';

export interface TmInfoEntry {
  t: string;
  ctx?: string;
  d: string;
  e: string;
  f: string;
  s?: string;
}

interface Props {
  infoKey: string | null;
  entries: Record<string, TmInfoEntry>;
  onClose: () => void;
}

/** apply-tooltip-pattern modal — prototype .info-modal styling */
export const TmInfoModal: React.FC<Props> = ({ infoKey, entries, onClose }) => {
  if (!infoKey || !entries[infoKey]) return null;
  const entry = entries[infoKey];

  return (
    <div className="tm-info-modal-overlay" onClick={onClose}>
      <div className="tm-info-modal" onClick={e => e.stopPropagation()}>
        <div className="tm-info-modal-head">
          <div>
            {entry.ctx && <div className="tm-info-ctx">{entry.ctx}</div>}
            <h3>{entry.t}</h3>
          </div>
          <button type="button" className="tm-info-modal-close" onClick={onClose}>✕</button>
        </div>
        <div className="tm-info-modal-body">
          <div className="tm-info-lbl">Description</div>
          <div className="tm-info-txt">{entry.d}</div>
          <div className="tm-info-lbl">Example</div>
          <div className="tm-info-ex">{entry.e}</div>
          <div className="tm-info-lbl">Formula</div>
          <div className="tm-info-formula">{entry.f}</div>
          {entry.s && (
            <>
              <div className="tm-info-lbl">Source data</div>
              <div className="tm-info-src">{entry.s}</div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export const TmQ: React.FC<{ onClick: () => void }> = ({ onClick }) => (
  <button type="button" className="tm-q" onClick={e => { e.stopPropagation(); onClick(); }} title="Explain">?</button>
);
